export default "__VITE_ASSET__109db005__"